export default "__VITE_ASSET__CHPtThoE__"